import React from 'react'

const Footer = () => {
  return (
   <h2 className='footer'>Developed by <span> <a href="https://github.com/asuman315"> Asuman Ssendegeya</a></span></h2>
  )
}

export default Footer